/*
* @Author: tengmaoqing
* @Date:   2018-06-13 20:16:38
* @Last Modified by:   tengmaoqing
* @Last Modified time: 2018-06-27 11:46:14
*/

const CONFIG = require('@/system/const/config');

module.exports = {
  name: '回收宝3',
  auth2LoginUrl: 'https://api.huishoubao.com/api/user/oauthLogin', // 第三方授权登录url
  loginType: '', // 登录方 nubia、 oppo、fql
  loginMethod: CONFIG.LOGIN_METHOD.PWD, // pwd, code
  platform: CONFIG.PLATFORM.H5, //
  productName: process.env.PROJECT_NAME, // 应用名
  wechatLoginPid: [1043, 1100, 1090, 1112, 1334]
};



// WEBPACK FOOTER //
// ./src/config/pid.config.js